import React from 'react';
import { Admin, Resource } from 'react-admin';

import './App.css';

import { Layout, Menu } from './layout';
import { Dashboard } from './dashboard';

import customer from './customers';
import vnnode from './vnnode';
import customerconfig  from './config';
import documentation from './documentation';
import customerconfigsweep  from './customerconfigsweeps';
import cbrestimate  from './cbrestimate';
import lintranscode  from './lintranscode';
import lintranscodev2  from './lintranscodev2';
import customertest  from './customertest';
//import release from './releases';
import customRoutes from './routes';
import themeReducer from './themeReducer';
import { withAuthenticator } from 'aws-amplify-react';
import authProvider from './authProvider';
import jsonAWSProvider from './cognito';
import errorSagas from './sagas/errorSagas';

const dataProvider = jsonAWSProvider("MyAPIGatewayAPI");

const App = () => (
    <Admin appLayout={Layout}
           customSagas={[ errorSagas ]}
           authProvider={authProvider}
           menu={Menu}
           customReducers={{ theme: themeReducer }}
           customRoutes={customRoutes}
           dashboard={Dashboard}
           dataProvider={dataProvider}>
        <Resource name="vnnode" {...vnnode}
                  options={{ label: 'VN-NODE' }}/>
        <Resource name="customer" {...customer}
                  options={{ label: 'Customers' }}/>
        <Resource name="customerconfig" {...customerconfig}
                  options={{ label: 'Configs' }}/>
        <Resource name="customertest" {...customertest}
                  options={{ label: 'Custom Tests' }}/>
        <Resource name="cbrestimate" {...cbrestimate}
                  options={{ label: 'CBR Estimates' }}/>
        <Resource name="lintranscode" {...lintranscode}
                  options={{ label: 'Linear Transcode' }}/>
        <Resource name="lintranscodev2" {...lintranscodev2}
                  options={{ label: 'Linear Transcode v2' }}/>
        <Resource name="documentation" {...documentation}
                  options={{ label: 'Documentation' }}/>
        <Resource name="user" />
        <Resource name="firstscreen" />
        <Resource name="customerconfigsweep" {...customerconfigsweep}
                  options={{ label: 'Custom Estimates' }}/>
    </Admin>
);

//export default App;
export default withAuthenticator(App, { includeGreetings: false });